import {Ref} from 'react';
import {useTranslation} from 'react-i18next';
import * as css from './TransactionDetails.css';
import {TEticketData} from '../../../../redux/eTicket/eTicket.type';
import TransactionDealSummary from '../TransactionDealSummary/TransactionDealSummary';
import TransactionInfoBlock from '../TransactionInfoBlock/TransactionInfoBlock';
import TransactionAddressBlock from '../TransactionAddressBlock/TransactionAddressBlock';
import TransactionPayment from '../TransactionPayment/TransactionPayment';

interface TransactionDetailsProps {
    data: TEticketData;
    scrollRef: Ref<HTMLDivElement>;
}

function TransactionDetails({data, scrollRef}: TransactionDetailsProps) {
    const {t} = useTranslation('eTicket');
    const {event, transaction, producer, order} = data;
    const ordererName = [order?.nameFirst, order?.nameLast].filter(Boolean).join(' ');
    const location = event?.location;
    const hasPayment = !!(order?.payMethod || order?.created);
    return (
        <css.body ref={scrollRef} data-cy="transaction-details">
            {transaction && <TransactionDealSummary transaction={transaction} />}
            {producer?.packageName && (
                <>
                    <css.separator />
                    <TransactionInfoBlock
                        heading={t('producerDetails')}
                        name={producer.packageName}
                        phone={producer.phone}
                        email={producer.email}
                        data-cy="transaction-producer" />
                </>
            )}
            {ordererName && (
                <>
                    <css.separator />
                    <TransactionInfoBlock
                        heading={t('ordererDetails')}
                        name={ordererName}
                        phone={order?.phone}
                        email={order?.email}
                        data-cy="transaction-orderer" />
                </>
            )}
            {location && (
                <>
                    <css.separator />
                    <TransactionAddressBlock location={location} />
                </>
            )}
            {hasPayment && order && (
                <>
                    <css.separator />
                    <TransactionPayment order={order} />
                </>
            )}
        </css.body>
    );
}

export default TransactionDetails;
